// extracted by mini-css-extract-plugin
module.exports = {"review-rate-item":"ReviewRateItem_review-rate-item__bpYZt","icon-wrapper":"ReviewRateItem_icon-wrapper__n6spI"};